import { DEFAULT_SORTING_PAYMENT_METHODS } from "../../constants";

const formatAppSettings = (settings = {}, type) => {
    if (type !== "order") {
        const payload = {
            sortingPaymentMethods: DEFAULT_SORTING_PAYMENT_METHODS,
            sbpEnabled: 1,
            yandexKassaEnabled: 1,
            payPalEnabled: 1,
            cloudPaymentsEnabled: 1,
            moscowCreditBankEnabled: 1,
            sberEnabled: 1,
            allowedPaymentMethodsCnt: 0
        };

        if (settings.sortingPaymentMethods) {
            payload.sortingPaymentMethods = settings.sortingPaymentMethods;
        }

        if (settings.paymentMethodDefault) {
            payload.paymentMethodDefault = settings.paymentMethodDefault;
        }

        if (Number.isInteger(settings.sbpEnabled)) {
            payload.sbpEnabled = settings.sbpEnabled;
            payload.sbpEnabled && payload.allowedPaymentMethodsCnt++;
        }

        if (Number.isInteger(settings.yandexKassaEnabled)) {
            payload.yandexKassaEnabled = settings.yandexKassaEnabled;
            payload.yandexKassaEnabled && payload.allowedPaymentMethodsCnt++;
        }

        if (Number.isInteger(settings.prodamusEnabled)) {
            payload.prodamusEnabled = settings.prodamusEnabled;
            payload.prodamusEnabled && payload.allowedPaymentMethodsCnt++;
        }

        if (Number.isInteger(settings.cloudPaymentsEnabled)) {
            payload.cloudPaymentsEnabled = settings.cloudPaymentsEnabled;
            payload.cloudPaymentsEnabled && payload.allowedPaymentMethodsCnt++;
        }

        if (Number.isInteger(settings.moscowCreditBankEnabled)) {
            payload.moscowCreditBankEnabled = settings.moscowCreditBankEnabled;
            payload.moscowCreditBankEnabled && payload.allowedPaymentMethodsCnt++;
        }

        if (Number.isInteger(settings.payPalEnabled)) {
            payload.payPalEnabled = settings.payPalEnabled;
            payload.moscowCreditBankEnabled && payload.allowedPaymentMethodsCnt++;
        }

        if (Number.isInteger(settings.sberEnabled)) {
            payload.sberEnabled = settings.sberEnabled;
            payload.moscowCreditBankEnabled && payload.allowedPaymentMethodsCnt++;
        }

        payload.is_facecastpro = settings.is_facecastpro || false;
        payload.agent_is_facecastpro = settings.agent_is_facecastpro || false;

        return payload;
    } else {
        const payload = {
            sortingPaymentMethods: {
                sbp: 0,
                yookassa: 1,
                cloudpayments: 2,
                sber: 3,
                mkb: 4,
                paypal: 5,
            },
            sbpEnabled: 0,
            yooKassaEnabled: 0,
            payPalEnabled: 0,
            cloudPaymentsEnabled: 0,
            moscowCreditBankEnabled: 0,
            sberEnabled: 0,
            allowedPaymentMethodsCnt: 0
        };

        settings.forEach(setting => {
            payload.sortingPaymentMethods[setting.type] = setting.order;

            if (setting.paymentMethodDefault) {
                payload.paymentMethodDefault = setting.paymentMethodDefault;
            }

            if (setting.type === "sbp") {
                payload.sbpEnabled = 1;
                payload.allowedPaymentMethodsCnt++;
            }

            if (setting.type === "cloudpayments") {
                payload.cloudPaymentsEnabled = 1;
                payload.allowedPaymentMethodsCnt++;
            }

            if (setting.type === "mkb") {
                payload.moscowCreditBankEnabled = 1;
                payload.allowedPaymentMethodsCnt++;
            }

            if (setting.type === "paypal") {
                payload.payPalEnabled = 1;
                payload.allowedPaymentMethodsCnt++;
            }

            if (setting.type === "yookassa") {
                payload.yooKassaEnabled = 1;
                payload.allowedPaymentMethodsCnt++;
            }

            if (setting.type === "sber") {
                payload.sberEnabled = 1;
                payload.allowedPaymentMethodsCnt++;
            }
        });
        return payload;
    }
};

export default formatAppSettings;
